const { parse } = require("date-fns")

module.exports = class AppTransformer {
  constructor(appUser) {
    this.appUser = appUser
  }

  transform() {
    return {
      classification: "User",
      email: this.appUser.email,
      identifier: this.appUser.email,
      name: this.appUser.name,
      createdAt: parse(this.appUser.joinDate, "yyyy/MM/dd", new Date()),
    }
  }
}
